"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var injection_js_1 = require("injection-js");
exports.FilesetName = new injection_js_1.InjectionToken("FilesetName");
var IFileStatus;
(function (IFileStatus) {
    IFileStatus["IN_PROGRESS"] = "in_progress";
    IFileStatus["COMPLETED"] = "completed";
    IFileStatus["ERROR"] = "error";
})(IFileStatus = exports.IFileStatus || (exports.IFileStatus = {}));
